// Report the fields rendered as unavailable, including panels initially closed.
export function reportWeatherFaqErrors() {
  const fields = new Set();
  document.querySelectorAll('[data-weather-unavailable^="faq-"]').forEach(element => {
    fields.add(element.getAttribute('data-weather-unavailable').slice(4));
  });
  const context = typeof twigData === 'undefined' ? {} : twigData;
  fields.forEach(field => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'error_hit', name: `data_aggregator_faq_${field.replace(/-/g, '_')}`,
      page: context.forecastPage || window.location.pathname,
      city_id: window.pageData && window.pageData.infoCity && window.pageData.infoCity.idcity });
  });
}

export default function initializeWeatherFaqTelemetry() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reportWeatherFaqErrors, { once: true });
  } else {
    reportWeatherFaqErrors();
  }
}
